import apiServices from '../../ApiServices/request-handler';
import { requestHandler } from '../../utils/functions';
import { showToast } from '../../utils/utils';
import {
  setAllocation,
  setBrokerage,
  setClientDetails,
  setClientLoading,
  setHoldings,
  setHoldingsLoading,
  setInitiatePaymentLoading,
  setInvestmentLoading,
  setPaymentsRecorded,
} from '../slices/investmentsSlice';

export const getClientData = (onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getClientDetails,
        setData: setClientDetails,
        setLoading: setClientLoading,
        onDone: (val) => {
          onDone && onDone(val?.result);
        }
      }),
    );
};

export const getBrokerageData = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getBrokerage,
        setData: setBrokerage,
        setLoading: setInvestmentLoading,
      }),
    );
};

export const getAllocationData = () => {
  return async (dispatch) => {
    dispatch(setInvestmentLoading(true));
    try {
      const allocation = await apiServices.getAllocation();
      const allocationGraph = await apiServices.getAllocationGraph();
      const allocationGraphGeography = await apiServices.getAllocationGraphGeography();

      const data = {
        allocation: allocation?.result,
        allocationGraph: allocationGraph?.result,
        allocationGraphGeography: allocationGraphGeography?.result,
      };

      dispatch(setAllocation(data));
    } catch (error) {
      showToast('error', error?.message);
    } finally {
      dispatch(setInvestmentLoading(false));
    }
  };
};

export const getHoldings = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getHoldings,
        setData: setHoldings,
        setLoading: setInvestmentLoading,
      }),
    );
};

export const getHoldingExportFile = (params, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getHoldingExportFile,
        param_data: params,
        onDone: (val) => onDone(val?.result),
      }),
    );
};

export const paymentsMoyassarHistory = (data) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.paymentsMoyassarHistory,
        param_data: data
      })
    );
  };
};

export const initiatePayment = (data) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.initiatePayment,
        param_data: data,
        setLoading: setInitiatePaymentLoading,
        onDone: (val) => {
          window.location.href = val.result.url
        }
      })
    );
  };
};
